document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.gallery-grid img').forEach(img => {
    img.addEventListener('click', () => {
      const lightbox = document.createElement('div');
      lightbox.classList.add('lightbox');
      lightbox.style.position = 'fixed';
      lightbox.style.top = 0;
      lightbox.style.left = 0;
      lightbox.style.width = '100vw';
      lightbox.style.height = '100vh';
      lightbox.style.background = 'rgba(0,0,0,0.85)';
      lightbox.style.display = 'flex';
      lightbox.style.alignItems = 'center';
      lightbox.style.justifyContent = 'center';
      lightbox.style.zIndex = 9999;

      const lightImg = document.createElement('img');
      lightImg.src = img.src;
      lightImg.style.maxWidth = '90%';
      lightImg.style.maxHeight = '90%';
      lightImg.style.borderRadius = '8px';

      lightbox.appendChild(lightImg);
      lightbox.addEventListener('click', () => lightbox.remove());
      document.body.appendChild(lightbox);
    });
  });
});
